cb.define([], function () {
  var RM_rm_shiftreceiptlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
	
    init: function (viewmodel) {
		
	let gridModel = viewmodel.getGridModel();	
	gridModel.on('afterSetDataSource', function(data){
		debugger;
		data.forEach(function(row, index) {
			
			if(typeof(row.reportName) != "undefined"){
				gridModel.setCellValue(index, 'reportShow', "点击查询静态报表");
			}
			
		}, this);
		
	});
	
	gridModel.on('beforeLoad', function (data){
			
			data.isDistinct = true;
		});
	
      viewmodel.getGridModel().on('jointQuery', function (args) {
        var rowData = args.rowData;
        viewmodel.communication({
          type: 'menu',
          payload: {
            menuCode: 'SJ0201',
            carryData: {
              query: {
                key: 'reportId',
                value: rowData.reportId
              },
              title: rowData.reportName
            }
          }
        });
      });
    }
  }
  try {
    module.exports = RM_rm_shiftreceiptlist_VM_Extend;
  } catch (error) {

  }
  return RM_rm_shiftreceiptlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_shiftreceiptlist_VM.Extend.js